
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { EditorContent, Editor } from 'tiptap'
import { CorrectAnswerOVO } from '@/views/biz/omr/vo/Omr.vo'
import { WrongAnswerNoteIVO } from '@/views/biz/note/vo/WrongAnswerNote.vo'
import { FileMstVO, FileOVO } from '@/views/bizcommon/file/vo/FileVO'
import { CommonCodeIVO, CommonCodeOVO } from '@/views/bizcommon/code/vo/CodeVO.vo'
import { TiptapVuetify,
        Heading, Bold, Italic, Strike, Underline, Code, Paragraph, BulletList, 
        OrderedList, ListItem, Link, Blockquote, HardBreak, HorizontalRule, History, 
        Image, Table, TableHeader, TableCell, TableRow, TodoList, TodoItem } from 'tiptap-vuetify'
import axios from 'axios'
import CommonUtils from '@/common-utils'
import Constants from '@/constants'

@Component({
  components: {TiptapVuetify}
})
export default class MemoFormDialog extends Vue {
  @Prop() correctAnswer !: CorrectAnswerOVO;

  editor: Editor = null as Editor;
  currentContentJson;
  loading = false;
  validForm = false;
  wrongAnswerNoteIVO = {} as WrongAnswerNoteIVO;
  uploadFile: FileMstVO = {} as FileMstVO;
  wnTypes: Array<CommonCodeOVO> = [] as Array<CommonCodeOVO>;
  

  extensions = [
    History,
    Blockquote,
    Link,
    Underline,
    Strike,
    Italic,
    ListItem,
    BulletList,
    OrderedList,
    [Heading, {
      options: {
        levels: [1, 2, 3]
      }
    }],
    Bold,
    Code,
    HorizontalRule,
    Paragraph,
    HardBreak,
    Image
  ];

  contentRules = [
    (v: string) => !!v || '내용을 입력해주세요.',
  ];

  async closeDialog() {
    const res =  await this.$confirm('풀이 작성을 취소 하실건가요?', CommonUtils.baseConfirmOption);
    if(res) {
      this.wrongAnswerNoteIVO = {} as WrongAnswerNoteIVO;
      this.$store.dispatch(`memoForm/closeModal`, {name: 'memoForm'})
    }
  }

  // 저장
  async saveMemoForm() {
    if(this.validForm && this.wrongAnswerNoteIVO.wnMemo) {
      this.loading = true;
      const res =  await this.$confirm('저장 하시겠어요?', CommonUtils.baseConfirmOption);

      this.wrongAnswerNoteIVO.caNo = this.correctAnswer.caNo;

      if(!res) {
        return;
      }

      // 저장
      if(!this.wrongAnswerNoteIVO.wnNo) {
        axios.post('wrong-answer-note/memo', this.wrongAnswerNoteIVO)
        .then(r => {
          this.wrongAnswerNoteIVO = {} as WrongAnswerNoteIVO;
          this.$store.dispatch(`memoForm/closeModal`, {name: 'memoForm'})
        })
      }

      // 수정
      if(this.wrongAnswerNoteIVO.wnNo) {
        axios.put('wrong-answer-note/memo', this.wrongAnswerNoteIVO)
        .then(r => {
          this.wrongAnswerNoteIVO = {} as WrongAnswerNoteIVO;
          this.$store.dispatch(`memoForm/closeModal`, {name: 'memoForm'})
        })
      }

      return this.loading = false;
    }
    this.validForm = false;
  }

  // 이미지 선택
  selectPhoto(): void {
    (this.$refs.memoFile as HTMLElement).click()
  }

  // 이미지 업로드
  async changeMemoPhoto(e) {
    const formData = new FormData();
    for(const file of e.target.files) {
      if(!file.type.match(e.target.accept)) {
        alert('이미지 파일만 가능해요');
        return;
      }

      formData.append("files", file);
    }
    formData.append("fileType", "memo");

    await axios.post('/common/upload-files', formData, {headers: {'Content-Type': 'multipart/form-data'}})
    .then(r => {
      const result = r.data;

      for(const file of result) {
        const uploadFile = file.file;

        const img = {
          constent: 'inline*',
          type: 'image',
          attrs: {
            src: uploadFile.fmUrl,
            alt: file.fileName,
            title: file.fileOrgNm
          }
        }

        this.currentContentJson = this.editor.getJSON();

        this.currentContentJson.content.push(img)
        this.editor.setContent(this.currentContentJson, true);
      }

    })
  }

  // 에디터 초기화시 초기 내용 저장
  // 사진을 추가한다거나 추 후, setContent함수를 이용해야 할 때 기본값이 없을 경우 에러남
  async onInit(editor) {
    this.editor = await editor.editor;
    this.editor.focus;
    this.currentContentJson = this.editor.getJSON();
  }

  @Watch('$store.state.memoForm.opened', {deep: true})
  editorInit(): void {
    if(this.$store.state.memoForm.opened == false) return; 

    axios.get(`wrong-answer-note/memo/${this.correctAnswer.caNo}`)
    .then(r=>{
      if(r.data.memo) {
        this.wrongAnswerNoteIVO = r.data.memo;
      } else {
        this.wrongAnswerNoteIVO.wnType =  '102';
      }

      this.wnTypes = r.data.wnTypes;

      this.editor.setContent(r.data.exContent)
      this.validForm = true;
    })
  }

  created(): void {
    this.currentContentJson || (this.currentContentJson = {content: []})
  }
}
